import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class SecurityInterceptor implements HttpInterceptor {
  private csrfToken: string | null = null;

  constructor() {
    this.generateCsrfToken();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.shouldAddCsrfToken(req)) {
      const csrfReq = req.clone({
        setHeaders: {
          'X-CSRF-Token': this.csrfToken || ''
        }
      });
      return next.handle(csrfReq);
    }
    return next.handle(req);
  }

  private generateCsrfToken(): void {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    this.csrfToken = Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
  }

  private shouldAddCsrfToken(req: HttpRequest<any>): boolean {
    return req.method !== 'GET' && req.method !== 'HEAD' && req.method !== 'OPTIONS';
  }

  getCsrfToken(): string | null {
    return this.csrfToken;
  }
}